
import { Component, Inject, Vue, Prop, Ref } from "vue-property-decorator"
import { Getter } from "vuex-class"

import PostComment from "./PostComment.vue"
import History from "./History.vue"
import { CaseDetails } from "@/types"
import CaseAuditHistoryService from "@/services/caseAuditHistoryService"

@Component({
	components: {
		"post-comment": PostComment,
		"history": History
	}
})
export default class CaseTimeline extends Vue {
	@Inject() caseAuditHistoryService!: CaseAuditHistoryService

	@Ref("history-view") historyView!: HTMLDivElement;

	@Prop({ default: null })
	currentCase!: CaseDetails | null;

	@Prop({ type: Boolean, default: false })
	canCreateComments!: boolean;

	@Getter("getCaseName") caseName!: string;
	@Getter("getRecordName") recordName!: string;

	public get getCaseOrRecordName () {
		return this.currentCase?.isCase ? this.caseName : this.recordName
	}

	private async refreshHistory (): Promise<void> {
		await this.caseAuditHistoryService.refresh()
	}
}
